import * as React from 'react'
import { useSearchParams } from 'react-router-dom'

import { QuoteQuery, QuoteSubview, QuoteView } from './types'
import { getQuoteSubview, getQuoteView } from './utils'

export const QuoteContext = React.createContext<{
  index: number
  ticker: string
  view: QuoteView | null
  subview: QuoteSubview | null
}>({ index: -1, ticker: '', view: null, subview: null })

export function QuoteContextProvider({
  ticker,
  index,
  children,
}: React.PropsWithChildren<{ ticker: string; index: number }>) {
  const [query] = useSearchParams()
  const type = query.get(QuoteQuery.Type) as QuoteView | QuoteSubview
  const contextValue = React.useMemo(
    () => ({ ticker, index, view: getQuoteView(type), subview: getQuoteSubview(type) }),
    [index, ticker, type]
  )

  return <QuoteContext.Provider value={contextValue}>{children}</QuoteContext.Provider>
}
